import { createActionTypes } from '.'

export const LOAD_LOCATIONS_INFO_FROM_CACHE = createActionTypes(
  'LOAD_LOCATIONS_INFO_FROM_CACHE',
)

export const SAVE_LOCATION_INFO = createActionTypes('SAVE_LOCATION_INFO')

export const GET_LOCATIONS_INFO = createActionTypes('GET_LOCATIONS_INFO')

export const GET_LOCATION_SUGGESTIONS = createActionTypes(
  'GET_LOCATION_SUGGESTIONS',
)

export const loadLocationsInfoFromCacheSuccess = (locations) => ({
  type: LOAD_LOCATIONS_INFO_FROM_CACHE.success,
  locations,
})

export const saveLocationInfo = (location) => ({
  type: SAVE_LOCATION_INFO.action,
  location,
})

export const saveLocationInfoSuccess = (locations) => ({
  type: SAVE_LOCATION_INFO.success,
  locations,
})

export const getLocationsInfo = (locIds, onComplete, isKeywordLocations) => ({
  type: GET_LOCATIONS_INFO.action,
  locIds,
  onComplete,
  isKeywordLocations,
})

export const getLocationsInfoSuccess = (locations) => ({
  type: GET_LOCATIONS_INFO.success,
  locations,
})

export const getLocationSuggestions = (query, onComplete) => ({
  type: GET_LOCATION_SUGGESTIONS.action,
  query,
  onComplete,
})

export const getLocationSuggestionsSuccess = (locations) => ({
  type: GET_LOCATION_SUGGESTIONS.success,
  locations,
})

export const LocationsInfo = sessionStorage
export const KEY_LOCATIONS_INFO = 'ub_locations_info'
